import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";

import ControlRow from "../utils/components/ControlRow";
import AddGroup from "./modals/AddGroup";
import EditGroup from "./modals/EditGroup";
import ConfirmationModal from "../utils/components/ConfirmationModal";
import AddUsersByPhone from "../utils/components/AddUsersByPhone";

import { setAlert } from "../../actions/alertActions";
import { searchModule, evioBase64 } from "../utils/Utils";

import "../../styles/utils/_loadingScreen.scss";
import "../../styles/components/chargers/Groups.scss";
import no_groups from "../../styles/images/no_groups.svg";
import plus from "../../styles/images/plus.svg";
import trashcan from "../../styles/images/trashcan.svg";
import cog from "../../styles/images/cog.svg";

class Groups extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      loading: true,
      isAdmin: false,
      search: "",
      groups: [],
      selectedGroup: null,
      selectedIndex: -1,
      selectedUser: null,

      modals: {
        add: false,
        delete: false,
        addParticipant: false,
        removeParticipant: false,
        editGroup: false,
      },
    };

    this.fetchGroups = this.fetchGroups.bind(this);
    this.handleOnSelect = this.handleOnSelect.bind(this);
    this.handleAddGroup = this.handleAddGroup.bind(this);
    this.handleEditGroup = this.handleEditGroup.bind(this);
    this.handleDeleteGroup = this.handleDeleteGroup.bind(this);
    this.handleAddParticipant = this.handleAddParticipant.bind(this);
    this.handleRemoveParticipant = this.handleRemoveParticipant.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchGroups();
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
  }

  fetchGroups() {
    axios
      .get("/api/private/groupCSUsers", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({ loading: false, groups: res.data }, () => {
            if (this.state.groups.length > 0) {
              let idx = -1;
              if (this.state.selectedGroup)
                idx = this.state.groups.findIndex(
                  (g) => g._id === this.state.selectedGroup._id
                );
              this.safeSetState({
                selectedGroup:
                  idx !== -1 ? this.state.groups[idx] : this.state.groups[0],
                selectedIndex: idx !== -1 ? idx : 0,
              });
            }
          });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleOnSelect(selectedGroup, selectedIndex) {
    this.safeSetState({
      selectedGroup,
      selectedIndex,
    });
  }

  handleAddGroup(elements, imageContent, listOfUsers) {
    const name = elements.groupName.value;

    const post = {
      name,
      imageContent: imageContent || evioBase64,
      listOfUsers,
    };
    axios
      .post("/api/private/groupCSUsers", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({ selectedGroup: res.data }, () => {
            this.props.setAlert(I18n.t("groups_addSuccess"), "primary");
            this.fetchGroups();
            this.setModal("add", false);
          });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleDeleteGroup(e) {
    axios
      .delete("/api/private/groupCSUsers", {
        data: { _id: this.state.selectedGroup._id },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({ selectedGroup: null }, () => {
            this.props.setAlert(I18n.t("groups_deleteSuccess"), "primary");
            this.fetchGroups();
            this.setModal("delete", false);
          });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleAddParticipant(users) {
    const listOfUsers = users.map((u) => ({
      userId: u._id,
      name: u.name,
      mobile:
        u.mobile || u.phone.replace(/[^0-9]+/g, "").slice(u.prefix.length),
      internationalPrefix: u.internationalPrefix || "+" + u.prefix,
    }));
    const put = { _id: this.state.selectedGroup._id, listOfUsers };
    axios
      .put("/api/private/groupCSUsers", put, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(
            I18n.t("groups_addParticipantSuccess"),
            "primary"
          );
          this.fetchGroups();
          this.setModal("addParticipant", false);
        }
      })
      .catch((err) => this.props.setAlert(I18n.t(err.response.code), "danger"));
  }

  handleRemoveParticipant() {
    const { userId, mobile, internationalPrefix } = this.state.selectedUser;
    const listOfUsers = [{ userId, mobile, internationalPrefix }];
    const patch = {
      _id: this.state.selectedGroup._id,
      listOfUsers,
    };

    axios
      .patch("/api/private/groupCSUsers", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(
            I18n.t("groups_removeParticipantSuccess"),
            "primary"
          );
          this.fetchGroups();
          this.setModal("removeParticipant", false);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleEditGroup(e, imageContent) {
    e.preventDefault();
    this.setModal("editGroup", false);

    const elements = e.target.elements;
    const name = elements.name.value;

    const patch = {
      _id: this.state.selectedGroup._id,
      name,
      imageContent: imageContent || evioBase64,
    };
    axios
      .patch("/api/private/groupCSUsers/update", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("myChargers_editGroupSuccess"), "primary");
          this.refreshContent();
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  refreshContent() {
    this.fetchGroups();
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return !this.state.loading ? (
      <div id="groups" className="main-container">
        <div className="control-bar">
          <ControlRow
            showSearch={this.state.selectedGroup !== null}
            search={this.state.search}
            onSearchChange={(e) => searchModule.setSearch(this, e.target.value)}
            showCarousel={this.state.selectedGroup !== null}
            carousel={{
              items: this.state.groups,
              selected: this.state.selectedIndex,
              onSelect: this.handleOnSelect,
            }}
            buttons={[
              {
                label: "groups_addGroup",
                text: plus,
                onClick: () => this.setModal("add", true),
                disabled:
                  this.state.loading ||
                  (this.props.isAdmin === false &&
                    this.state.groups.length >=
                      this.props.userPackage?.chargersGroupsLimit),
              },
              {
                show: this.state.selectedGroup !== null,
                text: (
                  <img src={cog} alt={I18n.t("myChargers_editChargerPlace")} />
                ),
                className: "clear",
                onClick: () => this.setModal("editGroup", true),
              },
              {
                show: this.state.selectedGroup !== null,
                text: <img src={trashcan} alt="" />,
                className: "clear delete-btn",
                onClick: () => this.setModal("delete", true),
              },
            ]}
          />
        </div>
        {this.state.groups.length === 0 && (
          <div className="no-groups">
            <img src={no_groups} alt="" />
            <p>
              <Translate value="groups_noGroupsText" />
            </p>
          </div>
        )}
        {this.state.selectedGroup !== null && (
          <>
            <div className="component-container">
              <div className="table-container">
                <div className="table-header">
                  <div className="row no-gutters">
                    <div className="col-12 row no-gutters titles">
                      <div className="col title">
                        <Translate value="groups_name" />
                      </div>
                      <div className="col title">
                        <Translate value="groups_phoneNumber" />
                      </div>
                      <div className="col-1 title">
                        {/* blank column for delete button */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-values">
                  {this.state.selectedGroup.listOfUsers
                    .filter((i) => searchModule.filter(this, i))
                    .map((u) => (
                      <div
                        key={u._id}
                        className={"row no-gutters " + (u.admin ? "admin" : "")}
                      >
                        <div className="col-12 row no-gutters values slim">
                          <div className={"col " + (u.admin ? "self" : "")}>
                            {u.name ? (
                              u.name
                            ) : (
                              <Translate
                                className="muted"
                                value="groups_notEvioUser"
                              />
                            )}
                          </div>
                          <div className="col">{`${u.internationalPrefix} ${u.mobile}`}</div>
                          <div className="col-1 center">
                            {!u.admin && (
                              <button
                                type="button"
                                className="clear"
                                style={{ marginLeft: "auto" }}
                                onClick={() =>
                                  this.safeSetState({ selectedUser: u }, () =>
                                    this.setModal("removeParticipant", true)
                                  )
                                }
                              >
                                <img src={trashcan} alt="" />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            <button
              type="button"
              className="add-participant-btn"
              onClick={() => this.setModal("addParticipant", true)}
              disabled={
                this.state.loading ||
                (this.props.isAdmin === false &&
                  this.state.selectedGroup.listOfUsers.filter((u) => !u.admin)
                    .length >= this.props.userPackage?.userInChargerGroupsLimit)
              }
            >
              <Translate value="groups_addParticipant" />
            </button>
          </>
        )}

        <AddGroup
          show={this.state.modals.add}
          onHide={() => {
            this.setModal("add", false);
            this.refreshContent();
          }}
          onSubmit={this.handleAddGroup}
        />

        <EditGroup
          show={this.state.modals.editGroup}
          onHide={() => {
            this.setModal("editGroup", false);
            this.refreshContent();
          }}
          onSubmit={this.handleEditGroup}
          selectedGroup={this.state.selectedGroup}
        />

        <AddUsersByPhone
          show={this.state.modals.addParticipant}
          onHide={() => {
            this.setModal("addParticipant", false);
            this.refreshContent();
          }}
          onSubmit={this.handleAddParticipant}
        />

        <ConfirmationModal
          show={this.state.modals.delete}
          onHide={() => {
            this.setModal("delete", false);
            this.refreshContent();
          }}
          title="groups_deleteGroup"
          body="groups_deleteGroupText"
          button="groups_deleteGroup"
          onConfirm={this.handleDeleteGroup}
        />

        <ConfirmationModal
          show={this.state.modals.removeParticipant}
          onHide={() => {
            this.setModal("removeParticipant", false);
            this.refreshContent();
          }}
          title="groups_removeParticipant"
          body="groups_removeParticipantText"
          button="groups_removeParticipant"
          onConfirm={this.handleRemoveParticipant}
        />
      </div>
    ) : (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="generic-loading">
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
});

export default connect(mapStateToProps, { setAlert })(Groups);
